// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","visibilityForm":"_1thctKMbbyY9k6H1caMOXM","visibilityFormHeader":"_3zHoooy7w-1pbikCOQyrZU","blocklistButton":"_1SjabE3Peo3tKWXl5hIsFL"};